/**
 * Funnel Offer Reminder Tour
 * Single-step nudge shown after funnel creation when the funnel contains an
 * offer / upsell / downsell step. Points the user at the offer node in the
 * canvas so they remember to pick which products to upsell.
 */

import type { Tour } from 'nextstepjs';
import { MousePointer2, ShoppingBag } from 'lucide-react';

export const funnelOfferReminderTour: Tour = {
    tour: 'funnel-offer-reminder',
    steps: [
        {
            icon: <MousePointer2 className="h-5 w-5" />,
            title: 'Pick your offers',
            content: (
                <div className="space-y-2">
                    <p>Don&apos;t forget to select the offers you want to show on this page.</p>
                    <p className="text-muted-foreground text-sm">
                        Click the step to open its editor.
                    </p>
                </div>
            ),
            selector: '[data-tour="offer-step"]',
            side: 'right',
            showControls: true,
            showSkip: false,
            pointerPadding: 15,
            pointerRadius: 12,
        },
        {
            icon: <ShoppingBag className="h-5 w-5" />,
            title: 'Configure your offers here',
            content: (
                <div className="space-y-2">
                    <p>This is where you choose which products to promote.</p>
                    <p className="text-muted-foreground text-sm">
                        Expand the section if it&apos;s collapsed, then add or toggle offers.
                    </p>
                </div>
            ),
            selector: '[data-tour="offer-config"]',
            side: 'left',
            showControls: true,
            showSkip: false,
            pointerPadding: 10,
            pointerRadius: 8,
        },
    ],
};

export function getFunnelOfferReminderTour(): Tour[] {
    return [funnelOfferReminderTour];
}
